export default "__VITE_ASSET__Dz3AHCE3__"